import React from "react";
import { Center } from "@chakra-ui/react";
import CheckIcon from "../CheckIcon";

export default function CheckboxCircle(props: { checked: boolean }) {
  return (
    <Center
      borderRadius="full"
      border="1px"
      borderColor="white"
      bgColor={props.checked ? "white" : "transparent"}
      // boxSize="25px"
      minW="25px"
      minH="25px"
      w="unset"
      h="unset"
    >
      {props.checked && <CheckIcon color="#FF5099" />}
    </Center>
  );
}
